import { defineStore } from "pinia";
import HomeTracker from '../../MetricsTracker/home/metrics';
import FooterTracker from '../../MetricsTracker/footer/metrics';
import { getDepositBanks, getDepositAccountName, getDepositContactEmail } from '../../utils/pricetravel/shared/bankUtils';
import { bankImageSizes } from '../../utils/constants/bankImageSizes';
const culture = window.__pt.culture;
const userLocation = window.__pt.userLocation;
const config = window.__pt.settings.site;
const tracker = new HomeTracker();
const trackerFooter = new FooterTracker();

const PaymentPromoBankOrder = [
    ['bbva'],
    ['santander'],
    ['scotiabankinverlat', 'scotiabank'],
    ['banamex', 'citibanamex'],
    ['banorte'],
    ['americanexpress', 'amex'],
    ['hsbc']
];

const normalizeBankName = (name = '') => name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toLowerCase();


export const useHomeStore = defineStore('home', {
    state: () => ({
        page: '',
        bannerTabs: {
            hotel: 'hotel',
            flight: 'flight',
            package: 'package',
            disney: 'disney'
        },
        topPaymentBanks: [],
        responsePayment: {
            fixedPayments: [],
            monthInterestFree: [],
            loading: true,
            depositBanks: [],
            depositAccountName: '',
            depositContactEmail: ''
        }
    }),
    getters: {
        getService: (state) => state.page,
        getTopPaymentBanks: (state) => state.topPaymentBanks,
        getResponsePaymentsMaxMSI: (state) => state.responsePayment.maxmsi,
        getResponsePaymentsMSI: (state) => state.responsePayment.monthInterestFree,
        getResponsePaymentsLoading: (state) => state.responsePayment.monthInterestFree,
        getResponsePaymentsDepositBanks: (state) => state.responsePayment.depositBanks,
        getResponsePaymentsDepositAccountName: (state) => state.responsePayment.depositAccountName,
        getResponsePaymentsDepositContactEmail: (state) => state.responsePayment.depositContactEmail
    },
    actions: {
        httpGetService() {
            let path = location.pathname.toLowerCase();
            path = path.replace(`/${culture.cultureCode}`, "");
            const Airlines = "aeromexico,aircanada,airfrance,avianca,boletosaereos,clicair,continental,copa,iberia,jetblue,jetsmart,latam,satena,united,vivaaerobus,volaris,wingo";
            const airlinesList = Airlines.split(',');
            const getSecondSegment = (path) => {
                const segments = path.split('/').filter(s => s.trim() !== "");
                return segments.length > 0 ? `/${segments[0]}` : "/";
            };
            const secondSegmentPath = getSecondSegment(path);
            switch (secondSegmentPath) {
                case '/':
                    this.page = config.siteName === "tiquetesbaratos" ? this.bannerTabs.flight : this.bannerTabs.hotel;
                    break;
                case '/hoteles':
                case '/hotels':
                    this.page = this.bannerTabs.hotel;
                    break;
                case '/vuelos':
                case '/flights':
                    this.page = this.bannerTabs.flight;
                    break;
                case '/paquetes':
                case '/packages':
                    this.page = this.bannerTabs.package;
                    break;
                case '/tiquetes':
                    this.page = this.bannerTabs.flight;
                    break;
                default:
                    const segments = path.split('/').filter(s => s.trim() !== "");
                    if (segments.length > 0) {
                        const lastSegment = segments[segments.length - 1];
                        const baseSegment = lastSegment.split('-')[0];
                        if (airlinesList.includes(baseSegment)) {
                            this.page = this.bannerTabs.flight;
                        } else {
                            page = config.siteName === "tiquetesbaratos" ? this.bannerTabs.flight : this.bannerTabs.hotel;
                        }
                    } else {
                        page = config.siteName === "tiquetesbaratos" ? this.bannerTabs.flight : this.bannerTabs.hotel;
                    }
                    break;
            }
        },
        showModal(id, btnTitle, btnText) {
            const el = document.getElementById(id)
            if (!el) return

            if (modal == "modal-payform" || modal == "modal-contact") {
                tracker.selectContent(btnTitle, btnText);
            }

            const modal = new Modal(el)

            modal.show();
        },
        async onSearchPaymentMethod() {
            if (
                this.responsePayment.fixedPayments.length ||
                this.responsePayment.monthInterestFree.length
            ) {
                return;
            }

            const params = {
                channel: config.channel,
                language: culture.internalCultureCode,
                currency: culture.currency,
                isdeposit: true
            };

            try {
                const response = await axios.get(
                    config.endPoints.paymentMethodUrl,
                    { params }
                );

                this.onSuccessPaymentMethods(response);
            } catch (error) {
                console.log(error);
            }
        },
        onSuccessPaymentMethods(response) {

            const data = response.data || [];
            const monthInterestFree = data.monthInterestFree ? data.monthInterestFree.options : [];
            const groupedPayments = monthInterestFree.reduce((groups, item) => {
                const maxMonths = Math.max(...item.paymentPlans);
                if (!groups[maxMonths]) {
                    groups[maxMonths] = [];
                }
                groups[maxMonths].push(item);
                return groups;
            }, {});
            const sortedEntries = Object.entries(groupedPayments).sort(([keyA], [keyB]) => Number(keyB) - Number(keyA));

            const depositBanks = getDepositBanks(data);
            const depositAccountName = getDepositAccountName(data);
            const depositContactEmail = getDepositContactEmail(data);

            const paymentMethods = {
                fixedPayments: data.fixedPayments
                    .map(fixedPayments => fixedPayments.options)
                    .reduce((prev, curr) => prev.concat(curr), []),
                monthInterestFree: sortedEntries,
                quotasPayments: data.quotasPayments ? data.quotasPayments.options : [],
                otherPayments: data.otherPayments ? data.otherPayments.options : [],
                depositBanks: depositBanks,
                depositAccountName: depositAccountName,
                depositContactEmail: depositContactEmail,
                loading: false,
                maxmsi: data.monthInterestFree ? data.monthInterestFree.title : ""
            };
            this.responsePayment = paymentMethods;
            this.topPaymentBanks = this.onTopPaymentBanks(monthInterestFree).map(bank => {
                const iconKey = bank.icon
                    ? `icon-brand-${bank.icon.toLowerCase()}-card`
                    : this.normalizeIcon(bank.name);
                const size = bankImageSizes[iconKey] || { width: 78, height: 26 };
                return {
                    ...bank,
                    icon: iconKey,
                    width: size.width,
                    height: size.height
                };
            });
        },
        onTopPaymentBanks(banks) {
            const availableBanks = [...banks]
                .filter(item => item.paymentPlans && item.paymentPlans.length > 0);
            return PaymentPromoBankOrder
                .map(aliases => availableBanks.find(bank => aliases.includes(normalizeBankName(bank.name))))
                .filter(Boolean);
        },
        normalizeIcon(name) {
            return `icon-brand-${name.toLowerCase().replace(/\s+/g, '')}-card`;
        },
        async onLoadPayment(modal, btnTitle, btnText) {
        this.showModal(modal, btnTitle, btnText);
        await this.onSearchPaymentMethod();
    }
}
});
